import { Box, Flex, Text } from '@chakra-ui/react';
import { TextBoldIcon } from 'ui-components';
import { FEATURE_FLAGS } from '~/constants';
import { useFeature } from '~/hooks/useFeatureFlag/useFeature';
import customTheme from '~/styles/theme';

import { useDropActions } from './useDropActions';

export const SideBarTextBox = () => {
  const { isEnabled } = useFeature(FEATURE_FLAGS.foamMediaKitsTextbox);
  const triggerActions = useDropActions();

  const handleClick = () => {
    triggerActions('EditableRichTextView');
  };

  if (!isEnabled) return null;

  return (
    <Box
      backgroundColor="neutral.100"
      border={`1px solid ${customTheme.colors.primary['100']}`}
      padding={4}
      borderRadius={8}
      cursor="pointer"
      onClick={handleClick}
      _hover={{ backgroundColor: 'neutral.200' }}
      transition="all 0.2s ease-in-out"
      track-id="add-text-to-media-kit"
      as="button"
    >
      <Flex gap={1} align="center" justify="center">
        <TextBoldIcon boxSize="14px" color="primary.700" />
        <Text fontSize="md" fontWeight="500" color="primary.700">
          Text
        </Text>
      </Flex>
    </Box>
  );
};
